import React from 'react';
import { Image } from './ImageGallery.styled';

const RenderItem = ({
  description,
  fullscreen,
  isFullscreen,
  onImageError,
  original,
  srcSet,
  originalAlt,
  originalHeight,
  originalWidth,
  originalTitle,
  sizes,
  loading,
  highestImage,
  isModifiedImageOnPrint,
}) => {
  const itemSrc = isFullscreen ? fullscreen || original : original;

  return (
    <>
      <Image
        src={itemSrc}
        alt={originalAlt}
        srcSet={srcSet}
        height={originalHeight}
        width={originalWidth}
        sizes={sizes}
        title={originalTitle}
        onError={onImageError}
        loading={loading}
        $styleHeight={highestImage}
        $isModifiedImageOnPrint={isModifiedImageOnPrint}
      />
      {description && (
        <span className='image-gallery-description'>{description}</span>
      )}
    </>
  );
};

export default RenderItem;
